import React from 'react';
import {Tag} from 'antd';

import fetch from './../fetch';
import utils from './../../utils';


const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'orgName', 
        label: '部门名称'
    },
    {
        key:'objName', 
        label: '对象', 
        width: 150, 
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'targetName', 
        label: '指标',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key: 'resultState',
        label: '诊改状态',
        render: (val) => {
            if(val === 1) {
                return <Tag color='blue'>未提交</Tag>
            } else if(val === 2) {
                return <Tag color='purple'>录入审核中</Tag> 
            } else if(val === 3) {
                return <Tag color='red'>录入审核不通过</Tag>
            } else if(val === 4) {
                return <Tag color='purple'>待考核</Tag>
            } else if(val === 5) {
                return <Tag color='red'>考核审核不通过</Tag>
            } else if(val === 6) {
                return <Tag color='green'>考核审核通过</Tag>
            } else if(val === 7) {
                return <Tag color='purple'>待考核审核</Tag>
            }
        }
    },
    {
        key:'submitEmployeeName', 
        label: '录入人',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'entryApprovalEmployeeName', 
        label: '录入审核人',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key:'examinationApprovalEmployeeName', 
        label: '考核审核人',
        width: 120,
        render: (value) => {
            return <label title={value}>{value}</label>
        }
    },
    {
        key: 'resultScore',
        label: '最终分数',
    },
    {
        key: 'submitTime', 
        label: '录入时间'
    },
    {
        key:'termName', 
        label: '所属学期'
    }
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zyzgview/query?' + params.join('&'),  Object.assign(defaultsParams, keywords))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const remove = (ids) => {
    return fetch.post('zyzgview/delete' , ids)
    // .then(response => {
    //     return response.payload.data;
    // })
    // return new Promise((resolve, reject) => {
    //     resolve({
    //         code: 200
    //     })
    // });
    // 如果要换成可用的接口，把下面的注释打开，把地址换成 api 即可。
    // return fetch.post(`zyzgevalresulttarget/delete/${id}`)
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    remove
}